var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCategoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 11a1.26 1.26 0 01-1.56 0L4.002 5.26c.305-.173.65-.263 1-.26h14c.35-.003.695.087 1 .26L12.78 11zm.94 1.18l7.19-5.74c.056.181.087.37.09.56v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7c.004-.19.034-.379.09-.56l7.19 5.74a2.77 2.77 0 003.44 0z",
    fill: "#545F7E"
  })));
}
export default SvgEventCategoryIcon;